import store from '../store'
import { revenueDefaults } from '../views/reports/revenue-defaults'

export function useSetRevenueDefaults(bid, reportMonth) {

  let invoicesBy = 'datePaid'

  let defaults = { ...revenueDefaults }
  let invoicesCounted = []
  let invoicesOutstanding = []
  let taxCollected = 0

  const roundCurrency = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100

  const getItemAmount = (item) => {
    const candidates = [
      item?.amount,
      item?.amountDue,
      item?.price,
      item?.total,
      item?.registration?.amount,
      item?.registration?.price,
      item?.registration?.cost
    ]

    for (const candidate of candidates) {
      const parsed = Number(candidate)
      if (!Number.isNaN(parsed) && Number.isFinite(parsed)) {
        return parsed
      }
    }

    return null
  }
  
  const moment = require('moment')
  const addSales = (defaults, registration, amount) => {
    let addTo
    if (registration) {
      switch (registration.event.type.id) {
        case 1: addTo = 'nzone_jr'; break
        case 2: addTo = 'nzone'; break
        case 3: addTo = 'nzone_adult'; break
        case 4: addTo = 'nzone_camp'; break
        case 5: addTo = 'nzone_comm'; break
        case 6: addTo = 'misc'; break
        default: addTo = 'additional'
        // default: throw new TypeError("Invalid registration type ", registration.event.type.id)
      }
      defaults[addTo + '_clients']++
    }
    defaults[addTo + '_sales'] += parseFloat(amount)
    return defaults
  }
  const processInvoices = (invoices) => {
    for (let i1 in invoices) {

      if (!invoices[i1].items.length) continue  // disregard invoices with no items
  
      let thisInvoice = invoices[i1]
  
      // filter out items with no registration (avoid mutating store data)
      const registeredItems = thisInvoice.items.filter(item => item.registration)
      if (!registeredItems.length) continue
  
      // separate invoices with no transaction id
      if (!thisInvoice.transactionId) {
        invoicesOutstanding.push(thisInvoice)
        continue
      }
  
      // update tax collected
      taxCollected += (thisInvoice.tax || 0)

      // subtract tax from invoice amount (does not count towards revenue)
      const invoiceNetAmount = Number(thisInvoice.amountDue || 0) - Number(thisInvoice.tax || 0)
  
      // update defaults
      let mappedWithItemAmounts = false
      for (let i2 in registeredItems) {
        let item = registeredItems[i2]
        const itemAmount = getItemAmount(item)
        if (itemAmount !== null) {
          mappedWithItemAmounts = true
          defaults = addSales(defaults, item.registration, itemAmount)
        }
      }

      // fallback: no item amount available, split invoice net amount across registered items
      if (!mappedWithItemAmounts) {
        const share = registeredItems.length ? (invoiceNetAmount / registeredItems.length) : 0
        for (let i2 in registeredItems) {
          let item = registeredItems[i2]
          defaults = addSales(defaults, item.registration, share)
        }
      }
  
      invoicesCounted.push(thisInvoice)
    }
  
    for (const key in defaults) {
      if (key.endsWith('_sales')) {
        defaults[key] = roundCurrency(defaults[key])
      }
    }

    taxCollected = roundCurrency(taxCollected)

    return {
      defaults,
      invoicesCounted,
      invoicesOutstanding,
      taxCollected
    }
  }
  
  const paramAfter = invoicesBy + '[after]'
  const paramBefore = invoicesBy + '[strictly_before]'
  const query = {
    business: bid,
    pagination: false
  }
  query[paramAfter] = moment(reportMonth?._d).format()
  query[paramBefore] = moment(reportMonth?._d).add(1, 'M').format()
  
  return store.dispatch('getInvoices', query).then(invoices => {
    return processInvoices(invoices)
  })
}